// import { AuthProvider, useAuth } from 'react-oidc-context';
import { WebStorageStateStore } from 'oidc-client-ts';

export const oidcConfig = {
  authority: `${process.env.REACT_APP_KEYCLOAK_URL}/realms/${process.env.REACT_APP_KEYCLOAK_REALM}`,
  client_id: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
  client_secret: process.env.REACT_APP_KEYCLOAK_CLIENT_SECRET,
  redirect_uri: `${window.location.origin}/`,
  response_type: 'code',
  scope: 'openid profile email',
  automaticSilentRenew: true, // enable automatic silent authentication
  userStore: new WebStorageStateStore({ store: window.localStorage }), // store user session
};

// export const oidcConfigUAT = {
//   authority: `${process.env.REACT_APP_KEYCLOAK_URL_UAT}/realms/${process.env.REACT_APP_KEYCLOAK_REALM_UAT}`,
//   client_id: process.env.REACT_APP_KEYCLOAK_CLIENT_ID_UAT,
//   client_secret: process.env.REACT_APP_KEYCLOAK_CLIENT_SECRET_UAT,
//   redirect_uri: `${window.location.origin}/`,
//   response_type: 'code',
//   scope: 'openid profile email',
// };